module.exports = __webpack_public_path__ + "static/media/homepage.3ed82bd8.svg";